const standardOptions = [
  {
    key: 'nenhum',
    label: 'Nenhum',
    value: 0,
  },
  {
    key: 'um_pouco',
    label: 'Um pouco',
    value: 1,
  },
  {
    key: 'moderadamente',
    label: 'Moderadamente',
    value: 2,
  },
  {
    key: 'muito',
    label: 'Muito',
    value: 3,
  },
  {
    key: 'extremamente',
    label: 'Extremamente',
    value: 4,
  },
]

export const ADCT = {
  questions: [
    {
      key: 'sintomas',
      name: 'Durante a última semana, como você classificaria seus sintomas relacionados ao eczema? ',
      options: [
        {
          key: 'nenhum',
          label: 'Nenhum',
          value: 0,
        },
        {
          key: 'leves',
          label: 'leves',
          value: 1,
        },
        {
          key: 'moderados',
          label: 'Moderados',
          value: 2,
        },
        {
          key: 'intensos',
          label: 'Intensos',
          value: 3,
        },
        {
          key: 'muito_intensos',
          label: 'Muito intensos',
          value: 4,
        },
      ],
    },
    {
      key: 'coceira',
      name: 'Durante a última semana, em quantos dias você teve episódios intensos de coceira por causa do seu eczema?',
      options: [
        {
          key: 'nenhum',
          label: 'Nenhum dia',
          value: 0,
        },
        {
          key: 'umadois',
          label: '1 a 2 dias',
          value: 1,
        },
        {
          key: 'tresaquatro',
          label: '3 a 4 dias',
          value: 2,
        },
        {
          key: 'cincoaseis',
          label: '5 a 6 dias',
          value: 3,
        },
        {
          key: 'todos',
          label: 'Todos os dias',
          value: 4,
        },
      ],
    },
    {
      key: 'eczema',
      name: 'Durante a última semana, em que grau você se sentiu incomodado com seu eczema?',
      options: standardOptions,
    },
    {
      key: 'sono',
      name: 'Durante a última semana, em quantas noites você teve dificuldades para pegar no sono ou permanecer dormindo por causa do seu eczema? ',
      options: [
        {
          key: 'nenhuma',
          label: 'Nenhuma noite',
          value: 0,
        },
        {
          key: 'umaaduas',
          label: '1 a 2 noites',
          value: 1,
        },
        {
          key: 'tresaquatro',
          label: '3 a 4 noites',
          value: 2,
        },
        {
          key: 'cincoaseis',
          label: '5 a 6 noites',
          value: 3,
        },
        {
          key: 'todos',
          label: 'Todos as noites',
          value: 4,
        },
      ],
    },
    {
      key: 'atividades_diarias',
      name: 'Durante a última semana, em que grau o seu eczema afetou suas atividades diárias? ',
      options: standardOptions,
    },
    {
      key: 'humor',
      name: 'Durante a última semana, em que grau o seu eczema afetou seu humor ou suas emoções? ',
      options: standardOptions,
    },
  ],
}
